/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Compression_HelpInputs */

const en_audio_description_export_automix_compression_help = /** @type {(inputs: Audio_Description_Export_Automix_Compression_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compression: Uses sidechain compression to automatically duck program audio when AD is detected.`)
};

const fr_audio_description_export_automix_compression_help = /** @type {(inputs: Audio_Description_Export_Automix_Compression_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compression : utilise une compression sidechain pour atténuer automatiquement l'audio du programme quand l'AD est détectée.`)
};

const de_audio_description_export_automix_compression_help = /** @type {(inputs: Audio_Description_Export_Automix_Compression_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komprimierung: Nutzt Sidechain-Komprimierung, um den Programm-Audiopegel automatisch zu senken, wenn AD-Signale erkannt werden.`)
};

const it_audio_description_export_automix_compression_help = /** @type {(inputs: Audio_Description_Export_Automix_Compression_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compressione: utilizza la compressione sidechain per attenuare automaticamente l'audio del programma quando viene rilevato AD.`)
};

const ru_audio_description_export_automix_compression_help = /** @type {(inputs: Audio_Description_Export_Automix_Compression_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сжатие: Использует сайдчейн-сжатие для автоматического приглушения звука программы при обнаружении AD.`)
};

const es_audio_description_export_automix_compression_help = /** @type {(inputs: Audio_Description_Export_Automix_Compression_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compresión: utiliza compresión de cadena lateral para atenuar automáticamente el audio del programa cuando se detecta AD.`)
};

const zh_cn2_audio_description_export_automix_compression_help = /** @type {(inputs: Audio_Description_Export_Automix_Compression_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`压缩：使用侧链压缩，在检测到 AD 时自动降低节目音频。`)
};

const ja_audio_description_export_automix_compression_help = /** @type {(inputs: Audio_Description_Export_Automix_Compression_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮: AD が検出されると、サイドチェーン圧縮を使用してプログラム オーディオを自動的にダッキングします。`)
};

const hi_audio_description_export_automix_compression_help = /** @type {(inputs: Audio_Description_Export_Automix_Compression_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपीड़न: विज्ञापन का पता चलने पर प्रोग्राम ऑडियो को स्वचालित रूप से कम करने के लिए साइडचेन संपीड़न का उपयोग करता है।`)
};

const pt_pt2_audio_description_export_automix_compression_help = /** @type {(inputs: Audio_Description_Export_Automix_Compression_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compressão: Utiliza compressão sidechain para reduzir automaticamente a atenuação do áudio do programa quando ocorre distorção de atenuação (AD).`)
};

/**
* | output |
* | --- |
* | "Compression: Uses sidechain compression to automatically duck program audio when AD is detected." |
*
* @param {Audio_Description_Export_Automix_Compression_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_compression_help = /** @type {((inputs?: Audio_Description_Export_Automix_Compression_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Compression_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_compression_help(inputs)
	if (locale === "de") return de_audio_description_export_automix_compression_help(inputs)
	if (locale === "it") return it_audio_description_export_automix_compression_help(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_compression_help(inputs)
	if (locale === "es") return es_audio_description_export_automix_compression_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_compression_help(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_compression_help(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_compression_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_compression_help(inputs)
	return en_audio_description_export_automix_compression_help(inputs)
});